import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { IoArrowBackSharp } from "react-icons/io5";
import Lottie from "lottie-react";
import empotyLottie from "../../../Assets/lottieFiles/emptybox.json"
import ReactLoading from "react-loading";
import KitchenMembershiplistCard from '../../../Components/KitchenMembershipCard/KitchenMembershiplistCard';
import NodeaxiosInstance from '../../../Services/nodeaxios';
import p_nav_previous from "../../../Assets/Images/p_nav_previous.svg";
import { useSelector } from 'react-redux';

const Kitchen_MemberShip_List = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const { flowParent, vendorName } = location.state || {};
    const [data, setData] = useState('')
    const [tickets, setTickets] = useState([])
    const [pageLoading, setPageLoading] = useState(true)
    let { vendor_id } = useParams();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const headers = { Authorization: userData?.token };


    const gettickets = async () => {
        try {

            const res = await NodeaxiosInstance.get('kitchen/fetch-membership-tickets', {
                params: {
                    vendor_id: vendor_id
                },
                headers
            });

            setTickets(res.data.result)
            setData(res.data)
            setPageLoading(true)

        }
        catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        gettickets()
        setTimeout(() => {
            setPageLoading(true);
        }, 2000);
    }, [])




    return (
        <div className=' '>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(`/vendor/${vendor_id}`)} />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                        Membership
                    </div>
                </div>
            </div>

            {
                pageLoading ?
                    <>
                        <div className='scroller-style-y p-2' style={{ paddingBottom: "50%" }}>
                            {
                                tickets.length > 0 ?
                                    tickets.map((item, index) => {
                                        return (
                                            <div className="p-1 ms-3 mt-2" key={index}>
                                                <KitchenMembershiplistCard item={item} />
                                            </div>
                                        )
                                    })
                                    :
                                    <>
                                        <div>
                                            <Lottie animationData={empotyLottie} />
                                        </div>
                                        <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Ticket Available</p>
                                    </>
                            }

                            <div style={{ height: 200 }}></div>
                        </div>
                    </> :
                    <div className="ReactLoading">
                        <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />
                    </div>
            }
        </div>
    )
}

export default Kitchen_MemberShip_List
